// eslint-disable-next-line import/prefer-default-export
export enum StockStatus {
  IN_STOCK = 'in_stock',
  BACK_ORDERED = 'back_ordered',
  OUT_OF_STOCK = 'out_of_stock',
  UNAVAILABLE_ADD_TO_CART = 'unavailable_add_to_cart',
  UNAVAILABLE = 'unavailable'
}
